import { Navigate } from "react-router-dom";

type AccessHook = () => { hasAccess: boolean; isLoading: boolean };

/**
 * Guards a gated portal feature (Marketing, Delivery Status, ...) against its
 * feature-access setting. Renders a spinner while the setting resolves so the
 * page never flashes.
 */
export function FeatureAccessRoute({ useAccess, children }: { useAccess: AccessHook; children: React.ReactNode }) {
  const { hasAccess, isLoading } = useAccess();

  if (isLoading) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }
  if (!hasAccess) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}
